import { CollectionType, toBaseProductType } from '@/collection/entity/CollectionType';
import { DriveItemType } from '@/drive/entities/DriveItem/DriveItem';
import { DriveItemId, isTemporaryDriveItemId } from '@/drive/entities/DriveItemId';
import { CollectionTreeItem } from '@/drive/entities/DriveTreeItem/CollectionTreeItem';
import { DriveTreeItem } from '@/drive/entities/DriveTreeItem/DriveTreeItem';
import { FolderTreeItem } from '@/drive/entities/DriveTreeItem/FolderTreeItem';
import { BaseProductType, formatBaseProductTypeLabel } from '@/product/constants/productTypes';
import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';
import { ProjectDataAccess } from '@/security/types/DataAccess';

export function createLocalCollectionItem(type: CollectionType): DriveTreeItem {
  return new CollectionTreeItem({
    id: -1,
    type: DriveItemType.Collection,
    title: 'New Collection',
    collectionId: '',
    collectionType: type,
    count: 0,
    access: GlobalAccessLevel.Restricted,
    dataAccess: ProjectDataAccess.HideProjectSource,
    canEdit: true,
    canManageAccess: true,
  });
}

export function createLocalFolderItem(): DriveTreeItem {
  return new FolderTreeItem({
    id: -1,
    type: DriveItemType.Folder,
    title: 'New Folder',
    count: 0,
    children: [],
    access: GlobalAccessLevel.Restricted,
    dataAccess: ProjectDataAccess.HideProjectSource,
    canEdit: true,
    canManageAccess: true,
  });
}

export function getCollectionDisabledReason(
  collection: CollectionTreeItem,
  productType: Nullable<BaseProductType>,
  itemsCount: number,
): string {
  const collectionProductsName = formatBaseProductTypeLabel(2, toBaseProductType(collection.collectionType));
  const restriction = `This collection can hold only ${collectionProductsName}`;

  if (itemsCount === 1) {
    return restriction;
  }

  if (productType) {
    const productsName = formatBaseProductTypeLabel(2, productType);

    return `Your pinned items are ${productsName}. ${restriction}`;
  }

  return `Your pinned items include different types. ${restriction}`;
}

export function prepareModalTreeItems(items: DriveTreeItem[], expandedIds: Set<DriveTreeItem['id']>): DriveTreeItem[] {
  return items
    .filter((item) => !isTemporaryDriveItemId(item.id as DriveItemId))
    .map((item) => {
      item.collapsed = !expandedIds.has(item.id);

      if (item.children) {
        item.children = prepareModalTreeItems(item.children, expandedIds);
      }

      return item;
    });
}
